export const HEADER_ACTIONS_ICON_SIZE = 16;
export const SELECTALL_DEALER = 'selectAllDealer';
export const OFFER_DETAILS_URL =
  'https://www.cat.com/en_US/promotions/finance/cat-card-offers.html';
export const OFFER_DETAILS_NEW_URL =
  'https://www.cat.com/en_US/support/financing-protection/financing-options/cat-card.html?softLogin';
export const CATFI_NO_THANKS = 'NO_THANKS_PROMO_OPTION';
export const ORDERED_BY_MODAL_TYPE = 'orderedBy';
export const REQUESTED_SHIP_DATE_MODAL_TYPE = 'requestedShipDate';
export const RBD_PARTS_AVAILABILITY_ESPOT = 'RBD_PARTS_AVAILABILITY_ESPOT';
export const CONTACT_DEALER = '[CONTACT_DEALER]';
export const RBD_UPDATE = 'RBDUpdate';
export const PCC_ESPOT_DEALER_TERMS_AND_CONDITIONS_SNP =
  'PCC_ESPOT_DEALER_TERMS_AND_CONDITIONS_SNP';
export const CMC_ESPOT_PCC_CATSAS_CATCARD_FINANCING_TERMS_CONDITIONS =
  'CMC_ESPOT_PCC_CATSAS_CATCARD_FINANCING_TERMS_CONDITIONS';
export const CMC_ESPOT_PCC_CATSAS_SUMMARYANDPAYMENT_CATCARD_LEARN_MORE =
  'CMC_ESPOT_PCC_CATSAS_SUMMARYANDPAYMENT_CATCARD_LEARN_MORE';
export const DEALER_CODE_ZEPPELIN_CZ = 'X190';
export const DEALER_CODE_ZEPPELIN_DE = 'L240';
export const WIDGET_LOADER_SIZE = 'small';
